import React from 'react';

import Modal from '~/components/modals/modal';

import styles from './modal.module.scss';

const GuaranteeModal = ({ onClose, isOpen }) => {
  return (
    <Modal onClose={onClose} isOpen={isOpen}>
      <div className={styles.guaranteeContainer}>
        <h1 className={styles.title}>better lawn guarantee</h1>
        <p
          className={styles.text}
          style={{ fontSize: '2rem', fontWeight: 700 }}
        >
          We’ve got what it takes to help you grow a better lawn.
        </p>
        <p className={styles.text}>
          We are committed to making sure Sunday works for you and your lawn.
          Need a replacement? We’ll ship it. Need help troubleshooting a lawn
          issue? Our experts are here for you. Not happy with your results?
          We’ll find a way to help your lawn. Just reach out to our Yard Advisor
          Team. We’re here to help you to grow a better lawn, guaranteed.
        </p>
        <img
          className={styles.guaranteeIcon}
          src="/icons/sunday-guarantee-badge-green.svg"
          alt="sunday-guarantee-badge-green"
        />
      </div>
    </Modal>
  );
};

export default GuaranteeModal;
